/**
 * hoodieApi — Reference Django backend (themamahood). Public exports.
 * Use for pages that consume the hoodie API. Other pages use mainApi (services/api.js).
 */

export { HOODIE_API_BASE_URL, isHoodieApiConfigured } from "./config";
export { hoodieFetch, hoodieFetchJson, hoodieFetchSession, hoodieFetchSessionJson, getCsrfToken } from "./hoodieClient";
export {
  getListings,
  getListingById,
  getTags,
  getTagGroupings,
  getEvents,
  getPromos,
  getSocialGroups,
  getMyProfile,
} from "./services/hoodieApi";
